define('view/module/AdaCompliantView',['require','lib/view/FormView','lib/view/UnwrapBehavior','Config'],function (require) {

    var FormView = require('lib/view/FormView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');
    var Config = require('Config');

    return FormView.extend({

        template: '#ada_compliant_module',

        modelEvents:  {
            'sync': 'render',
            'change': 'render',
            'invalid' : 'render'
        },

        ui: {
            data : ':input',
        },

        events : {

        },

        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        lastData : null,
        sendCounter : 0,

        initialize: function (options) {
            var _this = this;

            window.addEventListener("hashchange", function (){
                _this.render();
            });
        },

        _makeUrl : function (isAda){
            var config = Config.getInstance();
            var hash = '';
            var customQuery = null;
            if(config.getOption('custom_query')){
                customQuery = config.getOption('custom_query');
            }
            if(window.location.hash) {
                hash = window.location.hash.substring(1);
            }
            return  '/v2/?ada=' + (isAda?1:0) + (customQuery?'&'+customQuery:'') + (hash?'#' + hash:'');
        },

        serializeData: function () {
            var config = Config.getInstance();
            var res = this._serializeData();
            res = _.extend(res, {
                'ada_theme_url' : this._makeUrl(true),
                'base_theme_url' : this._makeUrl(false),
                'is_ada_compliant' : config.getOption('is_ada_compliant'),
                'is_widget' : config.getOption('is_widget'),
                'enabled' : this.model.get('enabled'),
            })
            return res;
        },



    });
});

